<template>
  <div class="workflow" v-if="workflowData.length > 0">
    <div class="headline" @click="toggleCollapse">
      <svg v-if="over" slot="dot" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-text-success"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path></svg>
      <svg v-else viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="loadingSvg"><path d="M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"></path></svg>
      <div>工作流</div>
      <a-icon :type="isCollapsed ? 'arrows-alt' : 'shrink'" />
    </div>
    <div class="content" v-show="!isCollapsed">
      <div class="item" :class="item.status" v-for="(item, index) of workflowData" :key="item.id">
        <span class="title">{{ item.title }}</span>
        <span v-if="item.status==='success'" class='time'>{{ item.time.toFixed(2) }}秒</span>
        <svg v-if="item.status==='success' || (workflowData[index + 1] && workflowData[index + 1].status==='success')" slot="dot" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="remixicon ml-2 h-3.5 w-3.5 shrink-0 text-text-success"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path></svg>
        <svg v-else viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="loadingSvg"><path d="M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"></path></svg>
      </div>
      <!-- <div class="item">
        <span class="title">通用逻辑</span>
        <span class='time'>{{ 32.21.toFixed(2) }}毫秒</span>
        
      </div> -->
    </div>
    <!-- <a-timeline>
      <a-timeline-item style="color: green;">开始</a-timeline-item>
      <a-timeline-item><a-icon  type="check" style="font-size: 14px;color:green" />通用逻辑</a-timeline-item>
      <a-timeline-item>
        <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;" />LLM
      </a-timeline-item>
      <a-timeline-item>直接回答</a-timeline-item>
    </a-timeline> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapsed: false
    }
  },
  props: {
    workflowData: {
      type: Array,
      default: () => ([{
        title: '开始',
        time: 32.21,
        status: 'success'
      }, {
        title: '通用逻辑',
        time: 152.21,
        status: 'loading'
      }])
    },
    over: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
.workflow{
  padding: 10px;
  background-color: #f8f8f8;
  .headline{
    display: flex;
    align-items: center;
    cursor: pointer;
    div{
      margin-right: 10px;
      margin-left: 4px;
    }
    .anticon {
      transition: transform 0.3s ease;
    }
    .anticon-shrink {
      transform: rotate(180deg);
    }
  }
  .content{
    margin-top: 10px;
  }
  .item{
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 32px;
    border-radius: 4px;
    padding: 0 10px;
    background-color: #fff;
    transition: background-color 0.3s ease;
    .title{
      margin-right: 10px;
      flex: 1;
    }
    .time{
      margin-right: 10px;
    }
  }
  .success{
    color: green;
  }
}
.text-text-success{
  color: green;
}
.loadingSvg{
  animation: spin 1s linear infinite;
  font-size: 12px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
